export const environment = {
  production: true,
  buildId: '2651351282218221',
  configFile: 'config.json',
};
